import type { FieldMergeFunction } from '@apollo/client'

export const mergeAcceptIncoming: FieldMergeFunction<unknown> = (_, incoming) => incoming
